import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { VANBANG_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { getUser } from '@app/utils/oidc';
import { messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import VanBangForm from './VanBangForm';

const VanBangAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) => Post(VANBANG_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        setIsLoading(true);
        try {
            const user = await getUser();
            const accountId = user?.profile?.sub;
            
            if (!accountId) {
                toast.error('Không lấy được thông tin tài khoản');
                setIsLoading(false);
                return;
            }

            const model = {
                accountId: accountId,
                tenVanBang: values.tenVanBang,
                loaiVanBang: values.loaiVanBang || null,
                chuyenNganh: values.chuyenNganh,
                coSoCapBang: values.coSoCapBang,
                quocGiaCap: values.quocGiaCap,
                soHieuVanBang: values.soHieuVanBang,
                ngayCap: values.ngayCap ? new Date(values.ngayCap).toISOString() : null,
                xepLoai: values.xepLoai || null,
                isHopPhapHoa: values.isHopPhapHoa,
                // Đảm bảo null số QĐ nếu bỏ chọn hợp pháp hóa
                soQDCongNhan: values.soQDCongNhan || null,
                fileMinhChungId: values.fileMinhChungId || null,
                ghiChu: values.ghiChu || null
            };

            addFunc.mutate(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastCreateError);
                    } else {
                        setIsLoading(false);
                        toast.success(messageToast.messageToastCreateSuccess);
                        history.push(URI_INTERNAL.VANBANG_PATH);
                    }
                },
                onError: (err) => {
                    setIsLoading(false);
                    toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });
        } catch (error) {
            setIsLoading(false);
            console.error('Lỗi tạo Văn bằng:', error);
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <VanBangForm
            title="Thêm mới Văn bằng"
            submitText="Lưu thông tin"
            initialValues={{
                tenVanBang: '',
                loaiVanBang: '',
                chuyenNganh: '',
                coSoCapBang: '',
                quocGiaCap: '',
                soHieuVanBang: '',
                ngayCap: '',
                xepLoai: '',
                isHopPhapHoa: false,
                soQDCongNhan: '',
                fileMinhChungId: '',
                ghiChu: ''
            }}
            onSubmit={handleCreate}
            onCancel={() => history.push(URI_INTERNAL.VANBANG_PATH)}
            isSubmitting={isLoading}
        />
    );
};

export default VanBangAdd;